import React from "react";
import Header from "../../components/header/header";
import { Container, Row, Col } from "react-bootstrap";
import "../../index.css";
import Footer from "../../components/footer/footer";
const Whoweare = () => {
  return (
    <div>
      {/* Header Section */}
      <Header />
      <section className="who-section py-5">
        <Container>
          <Row className="align-items-center">
            {/* Image First on Mobile, Second on Desktop */}
            <Col
              xs={12}
              md={6}
              className="order-1 order-md-2 text-center animate_animated animate_fadeInRight"
            >
              <img
                src="./images/brandjourney.webp" // ✅ Put image inside public/images/
                alt="Chocolate Chef"
                className="img-fluid rounded who-image"
              />
            </Col>
            {/* Content */}
            <Col
              xs={12}
              md={6}
              className="order-2 order-md-1 animate_animated animate_fadeInLeft values-box"
            >
              <h2 className="who-title montserrat-font text-uppercase">Who we are</h2>
              <p className="who-subtitle figtree-font"><b>" Chocolate is like poetry,</b><i> From the elegant rhythm of its making to the enchanting duet of
                sharing it with loved ones. The essence of chocolate is a living
                verse in every bite..."</i></p>
              <p className="who-text">
                Immersed in a world of art and music, our chocolates are a
                reflection of our inspiration. Crafted with traditional European
                techniques and equipment, they embody the essence of our
                creative journey...
              </p>
              <p className="who-text">From the first cacao tree...</p>
              <p className="who-text">Since the Aztecs used it as currency...</p>
              <p className="who-text">From 'xocolatl' to improvised Aztec's brew...</p>
              <p className="who-text">
                To the recent 'chocolates' of England and the Dutch mixes...
              </p>
              <p className="who-text">
                To the first solid chocolate mixing of cocoa powder with cocoa
                butter and sugar and milk in 1847...
              </p>
              <p className="who-text">
                Uncovering a modern day legend, SOULLIQO. Born out of sheer hard
                work of various experts over the years.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Footer Section */}
      <Footer />
    </div>
  );
};
export default Whoweare;
